import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useABTest } from '../hooks/useABTest';
import { useTracking } from '../lib/context/TrackingContext';

// Import all landing page variations
import ExhaustedLanding from './ExhaustedLanding';
import SdrRoiLanding from './SdrRoiLanding';
import SoulLanding from './SoulLanding';
import ClickerLanding from './ClickerLanding';

const ABTestLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { trackEngagement } = useTracking();
  
  // Check if a specific variant is requested via query param
  const queryParams = new URLSearchParams(location.search);
  const forcedVariant = queryParams.get('variant');
  
  // Define the variants for our test
  const { variant } = useABTest({
    testName: 'landing_page_variations',
    variants: ['exhausted', 'sdr-cost', 'soul', 'clicker'],
    // If a specific variant is requested and it's valid, use it
    defaultVariant: forcedVariant && ['exhausted', 'sdr-cost', 'soul', 'clicker'].includes(forcedVariant) 
      ? forcedVariant 
      : undefined,
    // Optional: You can adjust weights if you want to show some variations more often
    // weights: [1, 1, 1, 1], // Equal distribution (default)
  });

  useEffect(() => {
    // Track the variant assignment
    trackEngagement('variant_assignment', {
      variant,
      forced: !!forcedVariant,
      path: location.pathname,
      search: location.search,
    });
    
    // Redirect to the selected variant
    navigate(`/${variant}`, { replace: true });
  }, [variant, navigate, forcedVariant, trackEngagement, location.pathname, location.search]);

  // This component doesn't render anything directly as it redirects
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>Redirecting to the best experience for you...</p>
    </div>
  );
};

export default ABTestLanding; 